"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedVector2 = void 0;
const ValueObjects_1 = require("../ValueObjects");
class MemoizedVector2 {
    constructor(initialValue, onChangeCallback) {
        this._val = initialValue;
        this.onChangeCallback = onChangeCallback;
    }
    get val() {
        return this._val;
    }
    set val(v) {
        if (ValueObjects_1.Vector2.Equal(v, this._val))
            return;
        this._val = v;
        this.onChangeCallback();
    }
    setValQuietly(val) {
        this._val = val;
    }
}
exports.MemoizedVector2 = MemoizedVector2;
